import styled from "styled-components";

export const Wrapper = styled.section`
  display: grid;
  align-items: center;
  .logo-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 1.38rem;
  }
  .logo-text {
    margin-top: 0.5rem;
    margin-left: 0.5rem;
    color: var(--primary-600);
  }
  .form {
    max-width: 400px;
    border-top: 5px solid var(--primary-500);
  }
  h3 {
    text-align: center;
  }
  p {
    margin: 0;
    margin-top: 1rem;
    text-align: center;
  }
  .btn {
    margin-top: 1rem;
  }
  .member-btn {
    background: transparent;
    border: transparent;
    color: var(--primary-500);
    cursor: pointer;
    letter-spacing: var(--letterSpacing);
  }
`;
